import { ca } from '@cian/analytics';

export const trackEarlyAccessBannerShow = (): void => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'early_access_banner',
  });
};

export const trackEarlyAccessBannerClick = (): void => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_sopr',
    label: 'early_access_banner',
  });
};
